import store from "../redux/Store";
import Objects from "../redux/Objects";

export const history = require("history").createBrowserHistory();
history.listen(function (location) {
    if (!window.pushByHistory) {
        if (window.sessionLoaded) {
            if (location.pathname.startsWith("/hom")) {
                let token = store.getState().param[Objects.token]
                if (token) {
                    if (location.pathname === '/hom/login' ||
                        location.pathname === '/hom/register'||
                        location.pathname === '/hom/forgot-password'||
                        location.pathname === '/hom/send-code') {
                        window.pushByHistory = true
                        setTimeout(() => {
                            history.push('/hom')
                        }, 200)

                    }
                }
                else if(location.pathname !== '/hom/register' &&
                    location.pathname !== '/hom/forgot-password'&&
                    location.pathname !== '/hom/send-code'

                ){
                    if (!(location.pathname === '/hom/login')) {
                        window.pushByHistory = true
                        setTimeout(() => {
                            history.push('/hom/login')
                        }, 200)
                    }
                    return;
                }
            }
        }
    } else {
        window.pushByHistory = false
    }
});
